export class ReviewSet {
	id: string;
	title: string;
	caseId: string;
	status: 'pre-review' | 'reviewing' | 'post-review';
	documentsInReview: number;
	remainingDocuments: number;
	reviewedDocuments: number;
	totalDocuments: number;
}
